import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import EgwWebFont from "src/assets/EgwWebFont";
import IconView from "@/shared/components/IconView/IconView";
import { SortDirection } from "@/shared/utils/array";

import styles from "./sortIcons.module.scss";

const icons = [
  { icon: EgwWebFont["chevron-up"], direction: SortDirection.ASC },
  { icon: EgwWebFont["chevron-down"], direction: SortDirection.DESC },
];

const SortIcons = ({ highlightCurrent, sortDirection }) => (
  <div className={styles["sort-icons-container"]}>
    {icons.map((item) => {
      const { icon, direction } = item;
      const isActive = direction === sortDirection && highlightCurrent;

      return (
        <div className={styles["sort-icons"]} key={direction}>
          <IconView
            icon={icon}
            className={classNames(styles["sort-icon"], { [styles["is-active"]]: isActive })}
          />
        </div>
      );
    })}
  </div>
);

SortIcons.propTypes = {
  highlightCurrent: PropTypes.bool,
  sortDirection: PropTypes.string,
  toggleSort: PropTypes.func,
};

export default SortIcons;
